import React, {useEffect, useState} from 'react';
import {Alert, Button, Col, Form, FormGroup, Label, Row} from "reactstrap";
import Select from "react-select";
import {toast} from "react-toastify";
import ButtonLoader from "../../../../../share-components/ui/buttonLoader";
import PreLoader from "../../../../../share-components/ui/preLoader";
import {getProductFabricCareApi, saveProductFabricCareApi} from "../../../../../services/manage-product/productService";

const extractErrorMessage = (err, fallback) => {
    const data = err?.response?.data;
    if (typeof data === 'string') return data;
    return err?.message || fallback;
};

function FabricCare(props) {
    const {productId, closeDialog} = props;
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState('');
    const [buttonDisable, setButtonDisable] = useState(false);

    const [shortDescription, setShortDescription] = useState('');
    const [whyYouLoveItOptions, setWhyYouLoveItOptions] = useState([]);
    const [featureLabelOptions, setFeatureLabelOptions] = useState([]);
    const [selectedWhyYouLoveIt, setSelectedWhyYouLoveIt] = useState([]);
    const [selectedFeatureLabels, setSelectedFeatureLabels] = useState([]);

    const fetchData = () => {
        if (!productId) return;
        setLoading(true);
        setLoadError('');
        getProductFabricCareApi(productId).then(({response}) => {
            setShortDescription(response.short_description || '');
            setWhyYouLoveItOptions(Array.isArray(response.why_you_love_it_options) ? response.why_you_love_it_options : []);
            setFeatureLabelOptions(Array.isArray(response.feature_label_options) ? response.feature_label_options : []);
            setSelectedWhyYouLoveIt(Array.isArray(response.why_you_love_it_items) ? response.why_you_love_it_items : []);
            setSelectedFeatureLabels(Array.isArray(response.feature_labels) ? response.feature_labels : []);
        }).catch((err) => {
            setLoadError(extractErrorMessage(err, 'Failed to load Fabric & Care data.'));
        }).finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productId]);

    const onSave = () => {
        setButtonDisable(true);
        const payload = {
            short_description: shortDescription,
            why_you_love_it_ids: selectedWhyYouLoveIt.map(item => item.id),
            feature_label_ids: selectedFeatureLabels.map(item => item.id),
        };
        saveProductFabricCareApi(productId, payload).then(() => {
            toast.success("Fabric & Care saved successfully", {
                position: toast.POSITION.TOP_RIGHT,
            });
            setButtonDisable(false);
            closeDialog();
        }).catch(() => {
            // 422s are already surfaced globally by the API interceptor; just re-enable the
            // button so the user can fix the field and retry without reopening the modal.
            setButtonDisable(false);
        });
    };

    if (loading) {
        return <PreLoader/>;
    }

    if (loadError) {
        return (
            <>
                <Alert color="danger">{loadError}</Alert>
                <Row>
                    <Col sm="12">
                        <div className="float-right">
                            <Button color="secondary" onClick={closeDialog}>Close</Button>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }

    return (
        <Form onSubmit={(e) => {
            e.preventDefault();
            onSave();
        }}>
            <FormGroup>
                <Label className="col-form-label">Short Description</Label>
                <textarea
                    name="short_description"
                    className="form-control"
                    rows={3}
                    value={shortDescription}
                    onChange={(e) => setShortDescription(e.target.value)}
                    placeholder="e.g. A structured yet forgiving weave that holds its shape and moves with you"
                />
            </FormGroup>

            <FormGroup>
                <Label className="col-form-label">Why You'll Love It</Label>
                {whyYouLoveItOptions.length === 0 ? (
                    <div className="text-muted" style={{fontSize: 13}}>
                        No "Why You'll Love It" items configured yet. Add some under Product Setting.
                    </div>
                ) : (
                    <Select
                        isMulti
                        isClearable
                        placeholder="Select items..."
                        getOptionLabel={option => option.title}
                        getOptionValue={option => option.id}
                        options={whyYouLoveItOptions}
                        value={selectedWhyYouLoveIt}
                        onChange={(selected) => setSelectedWhyYouLoveIt(selected || [])}
                        menuPortalTarget={document.body}
                        components={{IndicatorSeparator: () => null}}
                        styles={{menuPortal: base => ({...base, zIndex: 100000})}}
                    />
                )}
            </FormGroup>

            <FormGroup>
                <Label className="col-form-label">Feature Labels</Label>
                {featureLabelOptions.length === 0 ? (
                    <div className="text-muted" style={{fontSize: 13}}>
                        No Feature Labels configured yet. Add some under Product Setting.
                    </div>
                ) : (
                    <Select
                        isMulti
                        isClearable
                        placeholder="Select labels..."
                        getOptionLabel={option => option.title}
                        getOptionValue={option => option.id}
                        options={featureLabelOptions}
                        value={selectedFeatureLabels}
                        onChange={(selected) => setSelectedFeatureLabels(selected || [])}
                        menuPortalTarget={document.body}
                        components={{IndicatorSeparator: () => null}}
                        styles={{menuPortal: base => ({...base, zIndex: 100000})}}
                    />
                )}
            </FormGroup>

            <Row style={{marginTop: 8}}>
                <Col sm={12}>
                    <div className="float-right">
                        <Button className="ml-3" color="secondary" type="button" onClick={closeDialog}>
                            Cancel
                        </Button>
                        <ButtonLoader
                            style={{marginLeft: 10, width: 'auto'}}
                            disabled={buttonDisable}
                            color="success"
                            type="submit"
                            btntext="Save"
                        />
                    </div>
                </Col>
            </Row>
        </Form>
    );
}

export default FabricCare;
